var exports = {
  "kR": "AssetSourceModal.module__cards___MF9PYm",
  "KI": "AssetSourceModal.module__cardsSingle___MF9PYm",
  "Nr": "AssetSourceModal.module__card___MF9PYm",
  "Ie": "AssetSourceModal.module__cardIcon___MF9PYm",
  "PY": "AssetSourceModal.module__cardLabel___MF9PYm",
  "eX": "AssetSourceModal.module__cardHint___MF9PYm",
};

module.exports = exports;
